<template>
  <el-row>
    <w-perf-analysis-time-info class="title-bar" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="loadOperaionInfo"/>
    <div class="title-bar title-h4">운영 정보</div>
    <el-row type="flex" class="list form-list" :gutter="20">
      <el-col :span="12">
        <el-form v-if="firstRscInfoList !== null" :model="operationData" label-width="30%">
          <el-form-item v-for="{rsctypeId, rscId} in firstRscInfoList" :key="`${rsctypeId}.${rscId}`" :label="getRscName(rscId)">
            {{ convertRscInfoData(rscId) }}
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form v-if="secondRscInfoList !== null" :model="operationData" label-width="30%">
          <el-form-item v-for="{rsctypeId, rscId} in secondRscInfoList" :key="`${rsctypeId}.${rscId}`" :label="getRscName(rscId)">
            {{ convertRscInfoData(rscId) }}
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import { analysisTimeType, defaultAnalysisTimeType } from '@/constants/performance';
import { mapGetters } from 'vuex';
import isNil from 'lodash/isNil';
import ceil from 'lodash/ceil';
import { isEmpty } from '@/utils/basic';
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT } from '@/utils/string';
import SensorAPI from '@/api/performance/sensor/sensor';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';

export default {
  name: 'WPerformanceSensorAnalysisTable',
  components: {
    WPerfAnalysisTimeInfo,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      analysisTimeType,
      operationData: {},
      checkDatetime: null,
      firstRscInfoList: null,
      secondRscInfoList: null,
      timeType: defaultAnalysisTimeType,
      isChangeNodeFlag: true, // true일 경우 (현재/이력) 모든 부분을 이력으로 변경한다.
    };
  },
  computed: {
    rscInfoList() {
      let rscInfoList;
      const objtypeId = this.selectedNode.obj.objtypeId;
      switch (objtypeId) {
        case 'FUPS': {
          rscInfoList = [
            {
              rsctypeId: objtypeId,
              rscId: 'INPUT_VOLTAGE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'OUTPUT_VOLTAGE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CAPACITY',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'LOADING',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'INPUT_FREQUENCY',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'OUTPUT_FREQUENCY',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'INPUT_CURRENT',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'OUTPUT_CURRENT',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_STATUS',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_VOLTAGE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CURRENT',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'INTERRUPT_INPUT_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'OPER_BYPASS',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'FREQUENCY',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'MODEL_NAME',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'SOFTWARE_VERSION',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'AGENT_SOFTWARE_VERSION',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'PHASE_VOLTAGE_R',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'PHASE_VOLTAGE_S',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'PHASE_VOLTAGE_T',
              rscKey: '_',
            },
          ];
          break;
        }
        case 'FTHEHYGRO': {
          rscInfoList = [
            {
              rsctypeId: objtypeId,
              rscId: 'CUR_TEMPERATURE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'SET_TEMPERATURE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CUR_HUMIDITY',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'SET_HUMMIDITY',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'SET_RUNNING_STATUS',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'RUNNING_STATUS_COLDROOM',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'RUNNING_STATUS_WARMROOM',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'RUNNING_INCREASE_HUMMIDITY',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'RUNNING_DECREASE_HUMMIDITY',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'WARN_HOT_TEMPERATURE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'WARN_HIGH_HUMMIDITY',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'WARN_TEMPERATURE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'WARN_LEAK',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'WARN_HUMIDITY',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'WARN_COMP1',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'WARN_COMP2',
              rscKey: '_',
            },
          ];
          break;
        }
        case 'FTH': {
          rscInfoList = [
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'HUMIDITY',
              rscKey: '_',
            },
          ];
          break;
        }
        case 'FTEMP': {
          rscInfoList = [
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE1',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE2',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE3',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE4',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE5',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE6',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE7',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE8',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE9',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE10',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE11',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE12',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE13',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE14',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE15',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE16',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE17',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE18',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE19',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TEMPERATURE20',
              rscKey: '_',
            },
          ];
          break;
        }
        case 'FWLDS': {
          rscInfoList = [
            {
              rsctypeId: objtypeId,
              rscId: 'WARN_LOSSOFFLOW',
              rscKey: '_',
            },
          ];
          break;
        }
        case 'FFIREDS': {
          rscInfoList = [
            {
              rsctypeId: objtypeId,
              rscId: 'FDA',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'FDB',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'FDH',
              rscKey: '_',
            },
          ];
          break;
        }
        case 'FSENSOR': {
          rscInfoList = [
            {
              rsctypeId: objtypeId,
              rscId: 'FMS_DOOR_STATUS',
              rscKey: '_',
            },
          ];
          break;
        }
        case 'FVSBMS': {
          rscInfoList = [
            {
              rsctypeId: objtypeId,
              rscId: 'PHASE_VOLTAGE_R',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'PHASE_VOLTAGE_S',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'PHASE_VOLTAGE_T',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'LINE_VOLTAGE_R',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'LINE_VOLTAGE_S',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'LINE_VOLTAGE_T',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CURRENT_R',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CURRENT_S',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CURRENT_T',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH1_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH2_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH3_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH4_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH5_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH6_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH7_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH8_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH9_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH10_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH11_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH12_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH13_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH14_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH15_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH16_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH17_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH18_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH19_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH20_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH21_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'REACTIVE_PWR',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'POWER_FACTOR',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'REACTIVE_PWR_Q',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'INTEGRATE_PWR_Q',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'FREQUENCY',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'HORIZONTAL_RADIATION',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'TILT_RADIATION',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'OUTSIDE_TEMPERATURE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'MODULE_TEMPERATURE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH22_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH23_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH24_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH25_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH26_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH27_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH28_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH29_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH30_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH31_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH32_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH33_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH34_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH35_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH36_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH37_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH38_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH39_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH40_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH41_POWER',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'CH42_POWER',
              rscKey: '_',
            },
          ];
          break;
        }
        case 'FGCU': {
          rscInfoList = [
            {
              rsctypeId: objtypeId,
              rscId: 'PHASE_VOLTAGE_R',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'PHASE_VOLTAGE_S',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'PHASE_VOLTAGE_T',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'LINE_VOLTAGE_R',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'LINE_VOLTAGE_S',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'LINE_VOLTAGE_T',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'PHASE_CURRENT_R',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'PHASE_CURRENT_S',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'PHASE_CURRENT_T',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_VOLTAGE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'OIL_PRESS',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'WATER_TEMP',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'POWER_FACTOR',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'APPARENT_PWR',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'ACTIVE_PWR',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'REACTIVE_PWR',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'GEN_FREQUENCY',
              rscKey: '_',
            },
          ];
          break;
        }
        case 'FRT': {
          rscInfoList = [
            {
              rsctypeId: objtypeId,
              rscId: 'DC_VOLTAGE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'DC_CURRENT',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_VOLTAGE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CURRENT',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CHARGING',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE1',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE2',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE3',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE4',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE5',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE6',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE7',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE8',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE9',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE10',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE11',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE12',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE13',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE14',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE15',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE16',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE17',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE18',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE19',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE20',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE21',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE22',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE23',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE24',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'LOAD_VOLTAGE',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'LOAD_CURRENT',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'LOAD_FACTOR',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'POWER_FACTOR_A',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'POWER_FACTOR_B',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'POWER_FACTOR_C',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE25',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE26',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE27',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE28',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE29',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE30',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE31',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE32',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE33',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE34',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE35',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE36',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE37',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE38',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE39',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE40',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE41',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE42',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE43',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE44',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE45',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE46',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE47',
              rscKey: '_',
            },
            {
              rsctypeId: objtypeId,
              rscId: 'BATTERY_CELL_VOLTAGE48',
              rscKey: '_',
            },
          ];
          break;
        }
        default:
          break;
      }
      return rscInfoList;
    },
    ...mapGetters(['selectedNode', 'plotLineDatetime']),
  },
  watch: {
    plotLineDatetime: {
      immediate: true,
      handler(value) {
        this.checkDatetime = this.plotLineDatetime;
        if (isNil(value)) {
          // operationData의 값이 있을시 초기화
          this.operationData = null;
          return;
        }
        this.selectedTabTableLoad();
      },
    },
    rscInfoList: {
      immediate: true,
      handler(list) {
        const length = list.length;
        if (length > 1) {
          const lastIdx = ceil(length / 2);
          this.firstRscInfoList = list.slice(0, lastIdx);
          this.secondRscInfoList = list.slice(lastIdx, length);
        } else {
          this.firstRscInfoList = list;
          this.secondRscInfoList = null;
        }
      },
    },
    /**
     * [분석] 탭이 활성화 시 현재 보여지는 탭의 데이터를 재로드한다.
     * @param  {[type]} active [description]
     * @return {[type]}        [description]
     * @author jda
     */
    active(active) {
      if (active) {
        this.selectedTabTableLoad();
      }
    },
    selectedNode: {
      handler() {
        if (!this.active) {
          return;
        }
        this.isChangeNodeFlag = true;
      },
      immediate: true,
    },
  },
  methods: {
    selectedTabTableLoad() {
      if ((isNil(this.plotLineDatetime)) || !this.active || isEmpty(this.selectedNode)) {
        return;
      }
      if (this.isChangeNodeFlag) {
        this.clearTimeType();
        this.$nextTick(() => {
          this.loadOperaionInfo();
          this.isChangeNodeFlag = false;
        });
      } else {
        this.loadOperaionInfo();
      }
    },
    /**
     * fms 센서별 운영정보를 가져온다.
     * @param  {[type]} rscInfo [description]
     * @return {[type]}         [description]
     * @author jda
     */
    loadOperaionInfo() {
      if (!this.active) {
        return;
      }
      const me = this;
      const rscIds = [];
      this.rscInfoList.forEach((item) => {
        rscIds.push(item.rscId);
      });
      if (this.timeType === this.analysisTimeType.HIST.value) {
        const params = {
          objId: this.selectedNode.obj.objId,
          baselineDatetime: this.plotLineDatetime,
          rsctypeId: this.selectedNode.obj.objtypeId,
          managetypeId: 'FMS',
          rscIds,
        };
        if (!isNil(this.plotLineDatetime)) {
          SensorAPI.getSensorOperationInfo(params).then((response) => {
            if (response.data.success) {
              me.operationData = response.data.data.snapshotDoc;
            }
          });
        }
      } else {
        const params = {
          objId: this.selectedNode.obj.objId,
          rsctypeId: this.selectedNode.obj.objtypeId,
          managetypeId: 'FMS',
          rscIds,
        };
        if (!isNil(this.plotLineDatetime)) {
          SensorAPI.getCurrentSensorOperationInfo(params).then((response) => {
            if (response.data.success) {
              me.operationData = response.data.data;
            }
          });
        }
      }
    },
    /**
     * 자원 값을 단위환산한다.
     * @param  {[type]} rscId [description]
     * @return {[type]}             [description]
     * @author jda
     */
    convertRscInfoData(rscId) {
      const operationData = this.operationData;
      if (isEmpty(operationData) || isEmpty(operationData[rscId])) {
        return EMPTY_TEXT;
      }
      return convertValuByUnit(operationData[rscId].value, operationData[rscId].rscUnit, true, null, false);
    },
    /**
     * 자원 이름을 반환한다.
     * @param  {[type]} rscId [description]
     * @return {[type]}       [description]
     * @author jda
     */
    getRscName(rscId) {
      const operationData = this.operationData;
      if (isEmpty(operationData) || isEmpty(operationData[rscId])) {
        return EMPTY_TEXT;
      }
      return operationData[rscId].rscName;
    },
    onTimeTypeChange(value) {
      this.timeType = value;
      this.loadOperaionInfo();
    },
    clearTimeType() {
      const hist = defaultAnalysisTimeType;
      this.timeType = hist;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/sensor/PerformanceSensorAnalysisTable.vue